import { isFeatureEnabled } from 'owa-feature-flags';
import getAttachmentPolicy from 'owa-session-store/lib/utils/getAttachmentPolicy';
import type { MailboxInfo } from 'owa-client-types';
import type AttachmentPolicyType from 'owa-service/lib/contract/AttachmentPolicyType';
import type RecursiveReadOnly from 'owa-service/lib/RecursiveReadOnly';

export default function getAttachmentPolicyBasedOnFlag(
    mailboxInfo: MailboxInfo
): RecursiveReadOnly<AttachmentPolicyType | undefined> {
    const attachmentPolicy = getAttachmentPolicy(mailboxInfo);

    // 'fwk-devTools' is a feature flag that enabled only on deployed-link / 'gulp'
    if (isFeatureEnabled('fwk-devTools')) {
        if (isFeatureEnabled('doc-attachment-CA-readOnlyAccessIssues')) {
            return {
                ...attachmentPolicy,
                DirectFileAccessOnPrivateComputersEnabled: false,
                DirectFileAccessOnPublicComputersEnabled: false,
                WacViewingOnPrivateComputersEnabled: true,
                WacViewingOnPublicComputersEnabled: true,
            };
        }
        if (isFeatureEnabled('doc-attachment-CA-readOnlyPlusAttachmentsBlocked')) {
            return {
                ...attachmentPolicy,
                DirectFileAccessOnPrivateComputersEnabled: false,
                DirectFileAccessOnPublicComputersEnabled: false,
                WacViewingOnPrivateComputersEnabled: false,
                WacViewingOnPublicComputersEnabled: false,
            };
        }
    }
    return attachmentPolicy;
}
